import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'graphql/MetamorphLoginCallback';

export const METAMORPH_LOGIN_CREATE_COMPANY = defineApiActionTypes(
  `${prefix}/METAMORPH_LOGIN_CREATE_COMPANY`
);
